<template lang="pug">
b-modal#themeContent(
  ref="themeContent"
  :title="$t('ui.content')"
  centered
  no-fade
  no-close-on-backdrop
  hide-footer
  :busy="loading"
  size="xl"
  @show="reset"
  @shown="shown")
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    .row(v-if="item != null")
      .col-12
        .card.mb-0
          .card-header
            .row.col-12
              .form-group.col-12
                b-input-group(size="sm")
                  b-input-group-text.border-0(slot="prepend")
                    i.fas.fa-book-open
                    span.ml-2  {{ item.provider_type }} - {{ item.theme_code }}
              .form-group.col-3
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    i.fas.fa-layer-group
                  ThemeContentGroupLookup(
                    ref="themeContentGroup"
                    size="sm"
                    required
                    type="array"
                    :disabled="loading"
                    haveAll=true
                    v-model="themeContentGroup"
                  )

              .form-group.col-6.mb-1
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-search"
                  :text="$t('ui.search')"
                  type="button"
                  @click="getThemeContentList()"
                  variant="primary"
                  size="sm"
                )
              .form-group.col-12(v-if="isAdmin && isEditAccess")
                b-button(@click="onAdd(item.theme_code)" type="button" variant="info" size="sm")
                  i.fa.fa-plus
                  span.ml-1 {{ $t("ui.combine.add_content") }}
          .card-body
            .row
              .col-12
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover
                    thead.thead-light
                      tr
                        th.text-center(width="3%")
                          span #
                        th(width="8%")
                          span(:title="$t('ui.content_id')") {{ $t('ui.content_id') }}
                        th(width="8%")
                          span(:title="$t('ui.parent_content_id')") {{ $t('ui.parent_content_id') }}
                        th(width="8%")
                          span(:title="$t('ui.theme_content_group')") {{ $t('ui.theme_content_group') }}
                        th(width="8%")
                          span(:title="$t('ui.position')") {{ $t('ui.position') }}
                        th.text-center(width="5%")
                          span(:title="$t('ui.sequence')") {{ $t('ui.sequence') }}
                        th.text-center(width="5%" v-if="isAdmin && isEditAccess")
                          span(:title="$t('ui.action')") {{ $t('ui.action') }}
                    tbody.clusterize-content
                      tr(v-if="themeContentList.length == 0")
                        td(colspan="7").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in themeContentList")
                        td.text-center
                          span(:title="index + 1") {{ index + 1 }}
                        td
                          span(:title="item.content_id") {{ item.content_id }}
                        td
                          span(:title="item.parent_content_id") {{ item.parent_content_id }}
                        td
                          span(:title="item.theme_content_group") {{ item.theme_content_group }}
                        td
                          span(:title="item.position") {{ item.position }}
                        td.text-center
                          span(:title="item.sequence") {{ item.sequence }}
                        td.actions.text-center.align-middle(v-if="isAdmin && isEditAccess")
                          span.mr-2
                            a.fa.fa-edit.btn.btn-ssm.btn-icon.btn-primary(
                              href="javascript:void(0)"
                              @click="onEdit(item)"
                              :title="$t('ui.edit')"
                              )
                          span(v-if="isThemeHide == 'false'")
                            a.fa.fa-trash.btn.btn-ssm.btn-icon.btn-danger(
                              href="javascript:void(0)"
                              @click="onDeleteNew(item)"
                              :title="$t('ui.delete')"
                              )
                          span(v-else)
                            a.fa.fa-trash.btn.btn-ssm.btn-icon.btn-danger(
                              href="javascript:void(0)"
                              @click="onDelete(item)"
                              :title="$t('ui.delete')"
                              )

    .row
      .col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}

  addthemecontent(ref="addThemeContent" @clicked="addThemeContent" :item="addContent" @failed="handleFailedContent")
  editthemecontent(ref="editThemeContent" :itemContent="selectedThemeContent" @clicked="afterEditContent" @failed="handleFailedContent")
  deletethemecontent(ref="deleteThemeContent" :itemContent="selectedThemeContent" @clicked="afterDeleteContent" @failed="handleFailedContent")
</template>

<script>
import config from "@/config";
import addthemecontent from "@/components/content/theme/addThemeContent.vue";
import editthemecontent from "@/components/content/theme/editThemeContent.vue";
import deletethemecontent from "@/components/content/theme/deleteThemeContent.vue";
import ThemeContentGroupLookup from "@/library/ThemeContentGroupLookup.vue";
import SubmitButton from "@/library/SubmitButton.vue";

export default {
  components: {
    addthemecontent,
    editthemecontent,
    deletethemecontent,
    ThemeContentGroupLookup,
    SubmitButton
  },
  props: {
    item: {
      type: Object
    }
  },
  data() {
    return {
      themeContentList: [],
      addContent: null,
      selectedThemeContent: null,
      themeContentGroup: "",
      provider_type: '',
      theme_name: '',
      theme_code: '',
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      isThemeHide: config.isThemeHide
    };
  },
  computed: {
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_theme");
    }
  },
  methods: {
    onAdd(e) {
      this.addContent = e;
      this.$refs.addThemeContent.$refs.addThemeContent.show();
    },
    onEdit(e) {
      e.theme_code = this.item.theme_code
      this.selectedThemeContent = e;
      this.$refs.editThemeContent.$refs.editThemeContent.show();
    },
    onDeleteNew(e) {
      e.theme_code = this.item.theme_code
      this.selectedThemeContent = e;
      this.$refs.deleteThemeContent.$refs.deleteThemeContent.show();
    },
    reset() {
      this.feedback.success = true;
      this.feedback.status = "";
      this.themeContentList = []
      this.provider_type = "";
      this.theme_name = "";
      this.theme_code = "";
      this.addContent = null
      this.selectedThemeContent = null
      this.themeContentGroup = ""
    },
    shown() {
      this.getThemeContentList();
    },
    getThemeContentList() {
      let url = config.getThemeContentListUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        theme_code: this.item.theme_code,
        theme_content_group: this.themeContentGroup
      };
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.themeContentList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    addThemeContent() {
      this.getThemeContentList();

      this.$helpers.showDialog(this.$t("ui.combine.add_content"), this.$t("message.success"), "success");
    },
    afterEditContent(item) {
      this.getThemeContentList();
      this.$helpers.showDialog(this.$t("ui.combine.edit_content"), this.$t("message.success"), "success");
    },
    afterDeleteContent(item) {
      this.getThemeContentList();
      this.$helpers.showDialog(this.$t("ui.delete"), this.$t("message.success"), "success");
    },
    onDelete(e) {
      this.$swal({
        title: this.$t("ui.delete"),
        text: this.$t("message.delete_content_confirm", { content: e.content_id + ' - ' + e.position }),
        type: "info",
        showCancelButton: true,
        allowOutsideClick: false
      }).then(result => {
        if (result.value) {
          this.confirmDelete(e);
        }
      });
    },
    confirmDelete: function(e) {
      let url = config.deleteThemeContentUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        theme_content_id: e.theme_content_id
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getThemeContentList();
                this.$helpers.showDialog(this.$t("ui.delete"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleFailedContent(tag, status) {
      this.$helpers.showDialog(this.$t("ui." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
